export default {
  // view
  title: 'Factoring data',
  contact: {
    title: 'Factoring contact',
    name: 'Name',
    document: 'CIF',
    residence: 'Residence',
    tradeName: 'Trade name',
    address: {
      title: 'Address',
      street: 'Street',
      postalCode: 'Postcode',
      town: 'City',
      city: 'Province',
      country: 'Country'
    },
    registrationData: {
      title: 'Registration data',
      book: 'Book',
      sheet: 'Sheet',
      folio: 'Folio',
      section: 'Section',
      volume: 'Volume',
      mercantileRegistry: 'Mercantile Registry',
      additionalRegistrationData: 'Additional details'
    },
    medium: {
      title: 'Medium contact',
      phone: 'Phone',
      fax: 'Fax',
      web: 'Web',
      email: 'Email',
      name: 'Name',
      additionalContactDetails: 'Additional details'
    }
  },
  payment: {
    title: 'Payment data',
    headers: {
      date: 'Date',
      amount: 'Amount',
      paymentMethod: 'Payment method'
    }
  },
  assignmentReference: {
    title: 'Assignment reference',
    name: 'Assignment reference text'
  },
  assignmentDocuments: {
    title: 'Assignment documents',
    headers: {
      documentCharacter: 'Document character',
      representationIdentity: 'Representation identity',
      documentType: 'Document type'
    }
  },
  // invoice register
  invoiceFactoring: {
    introFactoringData: 'Enter factoring data',
    requiredFields: '(*) Required fields',
    general: 'Factoring entity (Assignee)',
    registration: 'Registry information',
    payment: {
      title: 'Payment methods'
    },
    transferReferences: {
      title: 'Assignment references',
      clausuleLabel: 'Text of the assignment clause.'
    },
    transferDocuments: {
      title: 'Assignment documents',
      headers: {
        documentNature: 'Document nature',
        representationType: 'Representation type',
        documentType: 'Document type',
        newDocument: 'New assignment document'
      },
      form: {
        documentNature: 'Document nature',
        representationType: 'Representation type',
        documentType: 'Document type',
        repository: 'Electronic repository',
        repositoryName: 'Repository name',
        repositoryNameTooltip: '[CGN] Consejo General del Notariado, [ROLECE] Registro Oficial de Licitadores y Empresas Clasificadas del Estado, [REA] Registro Electrónico de Apoderamiento, [otros]',
        url: 'URL',
        reference: 'Electronic reference'
      }
    },
    paymentData: {
      title: 'Payment data',
      headers: {
        paymentDate: 'Fecha',
        amount: 'Importe',
        paymentMethod: 'Payment methods',
        newPayment: 'New payment'
      },
      form: {
        paymentDate: 'Payment date',
        amount: 'Amount',
        paymentMethod: 'Payment method',
        ibanCredited: 'IBAN Credited',
        ibanDebited: 'IBAN Debited'
      }
    }
  }
}
